import { DisplayableContent } from './model'

export enum SIgnalRNotificationEventType {
  DemoEventA = 'DemoEventA',
  SignalRConnected = 'SignalRConnected',
  SignalRDisconnected = 'SignalRDisconnected',
  ShareStarted = 'ShareStarted',
  ShareEnded = 'ShareEnded',
  ScreenshotShare = 'ScreenshotShare',
  ZoomShare = 'ZoomShare',
  CursorShare = 'CursorShare',
}

export enum NotificationEventType {
  UpdateInstrumentRoomConfiguration = 'UpdateInstrumentRoomConfiguration',
  UpdateWorklistNewBooking = 'UpdateWorklistNewBooking',
  UpdateWorklist = 'UpdateWorklist',
  DoctorAssignedToExam = 'DoctorAssignedToExam',
  DoctorRoomUnlocked = 'DoctorRoomUnlocked',
  ExamStatusOrRoomUpdated = 'ExamStatusOrRoomUpdated',
  DataUpdated = 'DataUpdated',
  ChatStarted = 'ChatStarted',
  ChatEnded = 'ChatEnded',
  ChatMessage = 'ChatMessage',
  DocumentUpdated = 'DocumentUpdated',
  QueueStatusUpdated = 'QueueStatusUpdated',
  DifExamTestSynced = 'DifExamTestSynced',
  ExamUpdated = 'ExamUpdated',
  CursorShare = 'CursorShare',
}

export type NegotiateApi = {
  url: string
  accessToken: string
  ttlInSeconds?: number
}

export interface BaseNotificationMessage {
  id?: string
  title?: string
}

export interface ShareNotificationMessage extends BaseNotificationMessage {
  type:
  | SIgnalRNotificationEventType.ShareStarted
  | SIgnalRNotificationEventType.ShareEnded
  data: DisplayableContent
}

export interface OtherNotificationMessage extends BaseNotificationMessage {
  type: Exclude<
    SIgnalRNotificationEventType,
    | SIgnalRNotificationEventType.ShareStarted
    | SIgnalRNotificationEventType.ShareEnded
  >
  data?: unknown
}

export type NotificationMessage =
  | ShareNotificationMessage
  | OtherNotificationMessage

export enum NotificationGroupEntity {
  Practice = 'Practice',
  Store = 'Store',
  Exam = 'Exam',
  ExamChat = 'ExamChat',
  Worklist = 'Worklist',
  DataMonitor = 'DataMonitor',
}

export enum NotificationEntityType {
  LegalEntity = 'legalEntity',
  Username = 'username',
  Store = 'store',
}

export enum SignalREvents {
  AppEvent = 'AppEvent',
  SignalRConnected = 'SignalRConnected',
  SignalRDisconnected = 'SignalRDisconnected',
}

export interface NegotiateResponse {
  url: string
  accessToken: string
  ttlInSeconds?: number
}

export type NotificationPayload = {
  message: NotificationMessage
  identifier: string
  target: 'users' | 'groups'
  connectionId?: string
}
